import { action, observable, reaction, makeObservable } from 'mobx';
import {
  ContentLookup,
  contentLookupService,
  VersionedContentLookup,
  X3Level,
  X4Unit
} from '../../../domain';
import {arrayToMap, Disposers, PromiseState} from '../../../lib/helpers';

export class X3LevelLoader {
  @observable.ref
  state: PromiseState<VersionedContentLookup> | null;
  @observable.ref
  lookup: ContentLookup | null;

  @observable.ref
  level: X3Level | null;
  @observable.ref
  units: readonly X4Unit[];
  @observable.ref
  unitById: { [index: number]: X4Unit };

  private readonly disposers = new Disposers();

  constructor(readonly levelId: number) {
    makeObservable(this);
    this.state = null;
    this.lookup = null;
    this.level = null;
    this.units = [];
    this.unitById = {};
    this.setup();
  }

  @action
  load = () => {
    if (this.state?.isPending === true)
      return;
    this.state = contentLookupService.load();
  };

  @action
  refresh = () => {
    if (this.state?.isPending === true)
      return;
    this.state = contentLookupService.refresh();
  };

  private setup() {
    this.disposers.add(reaction(
      () => this.state?.value,
      this.onStateChange));
  }

  @action
  private onStateChange = () => {
    this.lookup = null;
    this.level = null;
    this.units = [];
    this.unitById = {};
    if (this.state?.isResolved !== true)
      return;
    let lookup = this.state.value.lookup;
    let level = lookup.X3LevelById[this.levelId];
    if (level === undefined)
      return;
    this.lookup = lookup;
    this.level = level;
    this.units = level.Units!;
    this.unitById = arrayToMap(this.units, x => x.Id);
  };

  dispose = () => {
    this.disposers.dispose();
  };
}
